export enum TicketsTypesEnum {
  children = 'children',
  teenager = 'teenager',
  adult = 'adult',
  senior = 'senior',
}

export const ticketsTypes = [TicketsTypesEnum.children, TicketsTypesEnum.teenager, TicketsTypesEnum.adult, TicketsTypesEnum.senior];

export enum PassTypesEnum {
  weekday = 'weekday',
  weekend = 'weekend',
  halfDay = 'halfDay',
  twoDay = '2Day',
  sixDay = '6Day',
}

export const passTypes = [
  PassTypesEnum.weekday,
  PassTypesEnum.weekend,
  PassTypesEnum.halfDay,
  PassTypesEnum.twoDay,
  PassTypesEnum.sixDay,
];
